module.exports = __webpack_public_path__ + "static/media/2.6.8c111265.mp3";